export default {
    // ACTIONS
    SET_PAYMENT_DETAIL: "SET_PAYMENT_DETAIL",
    LOAD_STATE_SESSIONSTORAGE: "LOAD_STATE_SESSIONSTORAGE"
}
  